import { ErrorAndDescriptionRow } from '@ui-components/common/ErrorAndDescriptionRow'
import { AdditionalText } from '@ui-components/typography/Typography'
import { RefObject, useId } from 'react'
import { styled } from 'styled-components'

import { PlusIcon } from '../../assets/Icons'
import { Button } from '../Button'

export interface AddItemButtonProps {
  onClick: (event: React.BaseSyntheticEvent) => unknown
  label: string
  description?: string
  error?: string
  ref?: RefObject<HTMLButtonElement | null>
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const AddItemButton = (props: AddItemButtonProps) => {
  const descriptionId = useId()
  const errorId = useId()

  return (
    <Container>
      {props.description && <AdditionalText id={descriptionId}>{props.description}</AdditionalText>}
      <Button
        ref={props.ref}
        onClick={props.onClick}
        label={props.label}
        aria-describedby={descriptionId}
        icon={<PlusIcon />}
        compact={true}
        variant="plain"
      />
      <ErrorAndDescriptionRow error={props.error} id={errorId} />
    </Container>
  )
}
